import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'newhome',
    component: () => import('../views/newhome.vue'),
  },
  {
    path: '/wxt',
    name: 'wxt',
    component: () => import('@/views/wxt.vue'),
  },
  {
    path: '/statement',
    name: 'statement',
    component: () => import('../views/statement.vue'),
  },
  {
    path: '/partner',
    name: 'partner',
    component: () => import('../views/partner.vue'),
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('../views/join.vue'),
  },
  {
    path: '/advertisement',
    name: 'advertisement',
    component: () => import('../views/advertisement.vue'),
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('../views/company.vue'),
  },
  {
    path: '/introduce',
    name: 'introduce',
    component: () => import('../views/introduce.vue'),
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service.vue'),
  },
  {
    path: '/us',
    name: 'us',
    component: () => import('../views/us.vue'),
  },
  {
    path: '/phoneHome',
    name: 'phoneHome',
    component: () => import('../views/phone/home.vue'),
  },
  {
    path: '/phoneRegister',
    name: 'phoneRegister',
    component: () => import('../views/phone/register.vue'),
  },
  {
    path: '/phoneLogin',
    name: 'phoneLogin',
    component: () => import('../views/phone/login.vue'),
  },
  {
    path: '/phoneMain',
    name: 'phoneMain',
    component: () => import('../views/phone/main.vue'),
  },
  {
    path: '/setmeal',
    name: 'setmeal',
    component: () => import('../views/setmeal.vue'),
  },
  {
    path: '/setmealSnake',
    name: 'setmealSnake',
    component: () => import('../views/setmealSnake.vue'),
  },
  {
    path: '/app',
    name: 'appWebSite',
    component: () => import('../views/appWebSite.vue'),
  },

  {
    path: '/desk',
    name: 'desk',
    component: () => import('../views/desk.vue'),
  },

  {
    path: '/mentor',
    name: 'mentor',
    component: () => import('../views/mentor.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
